export default __webpack_public_path__ + "static/media/menu-black.ca06b776.svg";